import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planQueryKeys, plansApiTypeOptions } from '../constants'

export const useGetPlansQuery = ({
  projectId,
  type = plansApiTypeOptions.PROJECTS,
  search = '',
  page = 0,
  stateFilter = 'Active',
  sortBy = 'Title',
  sortDirection = 'ASC',
  options
}) => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      params: {
        search,
        page,
        stateFilter,
        sortBy,
        sortDirection
      }
    }
    const { data } = await api(
      `/api/plans-api/${type}/${projectId}/children`,
      config
    )

    return data
  }

  return useQuery({
    queryKey: [
      planQueryKeys.GET_PLANS,
      projectId,
      type,
      search,
      page,
      stateFilter,
      sortBy,
      sortDirection
    ],
    queryFn: handleQuery,
    enabled: !!projectId,
    ...options
  })
}
